function initNavigation() {
	var swapStyles = $('.si-nav-style__js');
	var swapImages = $('.si-img-swap__js');
	var buttonType = globalVar.buttonType;

	// swap all style related images
	swapImages.each(function (idx, image) {
		$(image).attr('src', function (index, attr) {
			return attr.replace('classic', buttonType);
		});
	});
	swapStyles.each(function (idx, nav) {
		$(nav).addClass('si-nav-style-' + buttonType);
	});

	attachNavEventListeners();
}

function showNavElements() {
	var navButtons = $('.si-nav__js');
	var navigation = slides[globalVar.curSlide].navElements || [];

	$(navButtons).hide();

	navigation.forEach(function (nav) {
		switch (nav) {
			case 'start-slide':
				$('#si-clock').show();
				$('#si-start').show();
				// $('#si-mute').show();
				break;
			case 'standard-home':
				$('#si-logo').show();
				$('#si-progress').show();
				$('#si-home').show();
				// $('#si-back').show();
				// $('#si-mute').show();
				if (getCompletionStatus()) {
					// $('#si-next').show();
				}
				break;
			case 'video-home':
				// $('#si-logo').show();
				// $('#si-progress').show();
				$('#si-home').show();
				// $('#si-back').show();
				// $('#si-mute').show();
				if (getCompletionStatus()) {
					// $('#si-next').show();
				}
				break;
			case 'standard-menu':
				$('#si-logo').show();
				$('#si-progress').show();
				$('#si-menu').show();
				// $('#si-back').show();
				// $('#si-mute').show();
				if (getCompletionStatus()) {
					// $('#si-next').show();
				}
				break;
			case 'video-menu':
				// $('#si-logo').show();
				// $('#si-progress').show();
				$('#si-menu').show();
				// $('#si-back').show();
				// $('#si-mute').show();
				if (getCompletionStatus()) {
					// $('#si-next').show();
				}
				break;
			case 'exit-slide':
				// $('#si-progress').show();
				$('#si-exit').show();
				$('#si-replay').show();
				// $('#si-mute').show();
				break;
			default:
				if (nav.indexOf('icon') !== -1) iconActions(nav);
				else if (nav[0] === '!') $('#si-' + nav.split('!')[1]).hide();
				else $('#si-' + nav).show();
				break;
		}
	});

	function iconActions(navStr) {
		var navData = navStr.split('*');

		var nav = navData[0];
		var multiplier = parseInt(navData[1]) || 1;

		var slideID = globalVar.curSlide;
		var iconTemplate = $($('.si-helper-icon')[0]);

		for (var i = 0; i < multiplier; i++) {
			var $icon = iconTemplate.clone();

			$icon
				.appendTo('#si-nav-container')
				.show()
				.addClass('si-' + nav)
				.addClass('si-' + nav + '-' + (i + 1));

			hideClickIcon($icon, slideID, i);
		}
	}
}

function attachNavEventListeners() {
	$('#si-home').on('click touch', function () {
		siAudio.sfx.click.play();
		jumpToSlide(globalVar.homeSlide);
	});

	$('#si-mute').on('click touch', function () {
		siAudio.sfx.click.play();
		toggleMute();
	});

	$('#si-menu').on('click touch', function () {
		siAudio.sfx.click.play();
		openSideMenu();
	});

	$('#si-full').on('click touch', function () {
		siAudio.sfx.click.play();
		toggleFullscreen();
	});

	$('#si-back').on('click touch', function () {
		siAudio.sfx.click.play();
		setTimeout(function () {
			slideAction(globalVar.curSlide, 'backAction');
		}, 100);
	});

	$('#si-next').on('click touch', function () {
		siAudio.sfx.click.play();
		setTimeout(function () {
			slideAction(globalVar.curSlide, 'nextAction');
		}, 100);
	});

	$('#si-replay').on('click touch', function () {
		siAudio.sfx.click.play();
		jumpToSlide(0);
	});

	$('#si-exit').on('click touch', function () {
		siAudio.sfx.click.play();
		window.close();
	});

	$('#si-start').on('click touch', function () {
		siAudio.sfx.click.play();
		slideAction(globalVar.curSlide, 'nextAction');
	});

	$('#si-submit').on('click touch', function () {
		var slideObj = slides[globalVar.curSlide];

		if (slideObj.type === 'form' && !validForm()) return;

		siAudio.sfx.click.play();
		var bol = checkQuestion(slideObj.type);
		handleAnswer(bol);
	});

	$('#si-reset').on('click touch', function () {
		var slideObj = slides[globalVar.curSlide];

		siAudio.sfx.click.play();
		switch (slideObj.type) {
			case 'dnd':
				resetDnd();
				break;
			case 'sort':
				resetSort();
				break;
			case 'quiz':
				resetQuiz();
				break;
			case 'hotspot':
				var $hotspots = $('#' + globalVar.curSlide).find(' .hotspot-button__js');

				resetHotspot(slideObj.hotspot, $hotspots, getHotspotModals($hotspots.length));
				break;
			case 'scratch':
				resetScratch();
			default:
				if (slideObj.customReset) {
					slideObj.customReset();
				}
		}
		if (slideObj[slideObj.type].customReset) {
			slideObj[slideObj.type].customReset();
		}
	});
	$('#si-custom-submit').on('click touch', function () {
		if (slides[globalVar.curSlide].type === 'form' && !validForm()) return;

		siAudio.sfx.click.play();
		if (slides[globalVar.curSlide].customSubmit) {
			slides[globalVar.curSlide].customSubmit();
		}
	});

	$('.si-menu-closer').on('click touch', function () {
		closeSideMenu();
	});
}

function hideClickIcon($icon, slideID, i) {
	var $slide = $('#' + slideID);

	$slide.off('mousedown.icon' + i);
	$slide.on('mousedown.icon' + i, function () {
		$icon.remove();
		$slide.off('mousedown.icon');
	});

	addToFunctionKey(slides[slideID], 'onExitAction', function () {
		if ($icon) $icon.remove();
	});
}

// function used by fullscreen nav button
function toggleFullscreen() {
	var element = document.documentElement;
	var fullscreen =
		document.fullscreenElement ||
		document.mozFullScreenElement ||
		document.msFullscreenElement ||
		document.webkitFullscreenElement;
	if (fullscreen) {
		var requestMethod =
			document.exitFullscreen ||
			document.webkitExitFullscreen ||
			document.webkitExitFullScreen ||
			document.mozCancelFullScreen ||
			document.msExitFullscreen;

		if (requestMethod) {
			requestMethod.apply(document);
		}
	} else {
		var requestMethod =
			element.requestFullscreen ||
			element.webkitRequestFullscreen ||
			element.webkitRequestFullScreen ||
			element.mozRequestFullScreen ||
			element.msRequestFullscreen;

		if (requestMethod) {
			requestMethod.apply(element);
		}
	}
}

function toggleMute() {
	if (globalVar.muted === undefined) {
		globalVar.muted = false;
	}

	var muted = globalVar.muted;
	var $muteButton = $('#si-mute');

	// If the course is already muted, we want to turn 'mute' off
	if (muted) {
		$muteButton.removeClass('muted');
		globalVar.muted = false;
		muteAudio(false);
		muteVideo(false);
	}
	// If the course is not muted, we want to turn 'mute' on
	else {
		$muteButton.addClass('muted');
		globalVar.muted = true;
		muteAudio(true);
		muteVideo(true);
	}
}

function muteAudio(muteIt) {
	if (muteIt === true) {
		console.log('Muting audio.');
		Howler.mute(true);
	} else {
		console.log('Unmuting audio.');
		Howler.mute(false);
	}
}

function muteVideo(muteIt) {
	var allVideoPlayers = videojs.getAllPlayers();

	if (muteIt === true) {
		console.log('Muting video.');
		// Make sure that all players that are not yet initialized will get set to muted by default
		videojs.options.muted = true;
		// Find all initialized players and mute them
		allVideoPlayers.forEach(function (player) {
			player.muted(true);
		});
	} else {
		console.log('Unmuting video.');
		// Make sure that all players that are not yet initialized will NOT get set to muted by default
		videojs.options.muted = false;
		// Find all initialized players and unmute them
		allVideoPlayers.forEach(function (player) {
			player.muted(false);
		});
	}
}

// function infoKeyboard() {
//     var infoItems = $('.infoItem');
//     var idx = 0;
//     $('#Info_Closer').focus();

//     $('body').on('keydown.drag', function (event) {
//         switch (event.keyCode) {
//             case 9: //restricts tab movement to info overlay elements
//                 event.preventDefault();
//                 if (idx < infoItems.length - 1) {
//                     idx += 1;
//                 } else {
//                     idx = 0;
//                 }
//                 $(infoItems[idx]).focus();
//                 break;
//             case 27: // allows user to press escape key to return to normal
//                 $('#Info_Closer').trigger('click');
//                 break;
//             default:
//                 return true;
//         }
//     });
// }
